import eyeFilledSvg from './eyeFilled.svg';
import lockClosedFilledSvg from './lockCloseFilled.svg';
import { TRUELAYER_REPAYMENT_TYPE } from '../EarlyRepaymentHelper';
import styles from './PaymentMethodInfo.module.css';

export function PaymentMethodInfo({
    selectedPaymentMethod
}: {
    selectedPaymentMethod: string;
}) {
    if (selectedPaymentMethod === TRUELAYER_REPAYMENT_TYPE) {
        return TruelayerPaymentMethodInfo();
    } else return null;
}

const TruelayerPaymentMethodInfo = () => (
    <div>
        <p className={styles.firstP}>
            Instant bank transfers work using Open Banking, so all your payments
            are:
        </p>
        <IconAndText
            icon={lockClosedFilledSvg}
            alt="closed lock icon"
            header="Secure"
            text="We will securely login to your bank using an encrypted
                end-to-end-connection"
        />
        <IconAndText
            icon={eyeFilledSvg}
            alt="eye icon"
            header="Private"
            text="Your credentials will never be made accessible to anyone"
        />
    </div>
);

const IconAndText = ({
    icon,
    alt,
    header,
    text
}: {
    icon: string;
    alt: string;
    header: string;
    text: string;
}) => (
    <div className={styles.iconAndText}>
        <img src={icon} alt={alt} />
        <div>
            <div className={styles.header}>{header}</div>
            {text}
        </div>
    </div>
);
